export default {"src":"/_next/static/image/public/images/ic_order_records.6dc82cc5cd894a2516265a865772f84b.svg","height":167,"width":126};